import watch from 'redux-watch';
import isEqual from 'is-equal';
class AbsComponent {
    watch = watch;
    isEqual = isEqual;

    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        this.name = _name;
        this.store = _store;
        this.actions = _actions;
        this.router = _router;
        this.el = _el;
    }
    
    setting(){}
    render(_data = {}){}
    addEvents(){}

} // end of class

export default AbsComponent;